import {
  GET_CONSTANTS,
  GET_CONSTANTS_SUCCESS,
  SUPPORT_CHAT_SOUND,
  UNREAD_CHAT_COUNT_ADMIN,
  SET_FORUM_READ_TOPICS,
  UNREAD_ERX_OFFLINE_COUNT,
  DOCTOR_AND_NURSE_LIST,
  SUPPORT_STAFF,
    CONSULT_NATURE_LIST, SET_FORUM_READ_COMMENTS, SET_TICKET_COUNT
} from "../constants/serverConstants";

export const getConstants = () => ({
    type: GET_CONSTANTS
});

export const getConstantsSuccess = data => ({
    type: GET_CONSTANTS_SUCCESS,
    payload: data
});

export const updateChatSoundStatus = data => ({
    type: SUPPORT_CHAT_SOUND,
    payload: data
});

export const updateUnreadChatCountAdmin = data => ({
    type: UNREAD_CHAT_COUNT_ADMIN,
    payload: data
});

export const setForumReadTopics = data => ({
    type: SET_FORUM_READ_TOPICS,
    payload: data
});


export const setForumReadComments = data => ({
  type: SET_FORUM_READ_COMMENTS,
  payload: data
});
export const setTicketCount = data => ({
  type: SET_TICKET_COUNT,
  payload: data
});

export const updateUnreadErxOfflineCount = data => ({
    type: UNREAD_ERX_OFFLINE_COUNT,
    payload: data
});

export const updateDoctorAndNurseList = data => ({
    type: DOCTOR_AND_NURSE_LIST,
    payload: data
});

export const updateConsultNatureList = data => ({
    type: CONSULT_NATURE_LIST,
    payload: data
});

export const updateSupportStaff = data => ({
    type: SUPPORT_STAFF,
    payload: data
});
